
import { SearchFilters } from '../../../apps/search/schemas'
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'

@Component
export default class SearchSummaryBarDetailsGuests extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({ required: false })
    slug?: string

  get hasDates(): boolean {
    const dates = this.searchFilters.dates
    if (!dates || (!dates.arrive && !dates.depart)) return false
    return true
  }

  get isFamily(): boolean {
    return this.adults >= 1 && this.children >= 1
  }

  get isOneAdultOnly(): boolean {
    return this.adults === 1 && this.children === 0
  }

  get isAdultsOnly(): boolean {
    return (this.adults >= 1 && this.children === 0) || this.isDefault2Adults
  }

  get isDefault2Adults(): boolean {
    return this.hasDates && this.adults === 0 && this.children === 0
  }

  get isChildrenOnly(): boolean {
    return this.adults === 0 && this.children >= 1
  }

  get ifGuests() {
    return (
      this.isFamily ||
      this.isOneAdultOnly ||
      this.isAdultsOnly ||
      this.isChildrenOnly
    )
  }

  get adults() {
    const party = this.searchFilters.party
    return party ? party.adults : 0
  }

  get children() {
    const party = this.searchFilters.party
    return party ? party.childAges.length : 0
  }

  get label() {
    const groupSize = this.adults + this.children
    return this.ifGuests && groupSize
      ? this.$t('{people} people', { people: groupSize })
      : ''
  }
}
